import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class SayacYeriListeAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "SayacYeriListe";
        super(baseUrl);
    }

    getSayacYeriListe() {

        return this.get("", false);
    }
}
export default new SayacYeriListeAPI()